import '../CsvJsonInfoPages.scss';


function OptionRelationships() {

    const data = [
        { field: 1, description: 'Period Code (Int)' },
        { field: 2, description: 'CAP ID (Int)' },
        { field: 3, description: 'Date Effective From (Date)' },
        { field: 4, description: 'Date Effective To (Date)' },
    ];


    const data2 = [
        { field: 1, description: 'Rule Code (Int)' },
        { field: 2, description: 'Period Code (Int)' },
        { field: 3, description: 'Rule Type (Char)' },
    ];

    const data3 = [
  { field: 1, description: 'Rule Code (Int)' },
  { field: 2, description: 'Option Code (Int)' },
  { field: 3, description: 'Is Primary (TinyInt)' },
];





    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Option Relationships</h1>
            <p>This file describes how Options relate to each other. <br /><br />
                <b>Relationship Periods</b><br />
                <p>Describes the periods when the relationships are valid.</p>
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDRelationshipPeriods.txt .txt<br />
                LIGHTS_yyyy-mm-dd_NVDRelationshipPeriods.txt .txt<br />
                HEAVIES_yyyy-mm-dd_NVDRelationshipPeriods.txt .txt<br />
                BIKES_yyyy-mm-dd_NVDRelationshipPeriods.txt .txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
                <b>Relationship Rules</b><br /><br />
                Describes the rules for given types<br /><br />

                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDRelationshipRules.txt .txt<br />
                LIGHTS_yyyy-mm-dd_NVDRelationshipRules.txt .txt<br />
                HEAVIES_yyyy-mm-dd_NVDRelationshipRules.txt .txt<br />
                BIKES_yyyy-mm-dd_NVDRelationshipRules.txt .txt<br /><br />

                Note: yyyymmdd represents the date of the product. E.g. 20030701 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data2.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            Note: The rule type can contain the following values:<br />
            OO    -    One of - From the linked options, a maximum of one may be selected<br />
            RA    -    Requires all - If the primary option is selected, it must be accompanied by all linked options<br />
            RO    -    Requires one of - If the primary option is selected, at least one of the linked options must also be selected<br />
            NW   -    Not with - If the primary option is selected, none of the linked options may also be selected<br />
            IN     -     Included In - The linked options are automatically included as part of the primary option. The primary option is often a pack. The price of the pack also includes the linked options.<br />
            IO     -     Include One Of - If the primary option is chosen, it must be accompanied by one none primary options. The selected none primary option will be included at 0 cost. Example : If Convenience Pack is selected One Metallic Paint can also be selected at 0 cost.<br />

            <p>
                <b>Relationship Items</b><br /><br />
                This lists the options associated with a rule.<br /><br />

                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br/><br/>

                CAR_yyyy-mm-dd_NVDRelationshipItems.txt .txt<br/>
                LIGHTS_yyyy-mm-dd_NVDRelationshipItems.txt .txt<br/>
                HEAVIES_yyyy-mm-dd_NVDRelationshipItems.txt .txt<br/>
                BIKES_yyyy-mm-dd_NVDRelationshipItems.txt .txt<br/><br/>

                Note: yyyymmdd represents the date of the product. E.g. 20030701 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data3.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

    );
}

export default OptionRelationships;
